import { NamingConvention } from "namirasoft-core";
import { BaseColumnFormatter } from "./BaseColumnFormatter";

export enum StringFormatterSizeType 
{
    Word = "75px",
    TwoWords = "150px",
    FullName = "225px",
    Sentence = "350px",
    Description = "500px",
}

export class StringFormatter extends BaseColumnFormatter
{
    static toHTML(value: string | null | undefined)
    {
        value = value?.trim() ?? "";
        let toks = value.split(/(\n|\\n|<br>|<br\s*\/>)/gm);
        toks = toks.filter(x => x.replace(/(\n|\\n|<br>|<br\s*\/>)/gm, "").trim().length > 0);
        if (toks.length === 1)
            return value;
        let ans = [];
        for (let i = 0; i < toks.length; i++)
        {
            if (i > 0)
                ans.push(<br key={i} />);
            ans.push(toks[i].trim());
        }
        return ans;
    }
    private naming: NamingConvention | null;
    constructor(width: string = StringFormatterSizeType.Sentence, naming: NamingConvention | null = null)
    {
        super();
        this.width = width;
        this.naming = naming;
    }
    override format(value: any): any
    {
        if (this.naming)
            value = NamingConvention.auto.convert(value, this.naming);
        return value;
    }
}